import React, { useState, useEffect } from "react";
import { db } from "../../firebaseConfig";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

import {
  Heart,
  Phone,
  MapPin,
  Menu,
  X,
  Mail,
  Facebook,
  Instagram,
  Clock,
  Send,
  MessageCircle,
  User,
  MessageSquare,
  Check,
} from "lucide-react";

export default function ContactPage() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    service: "",
    message: "",
  });
  const [submitStatus, setSubmitStatus] = useState({
    show: false,
    success: false,
    message: "",
  });
  useEffect(() => {
    // Scroll to top when this page loads
    window.scrollTo(0, 0);
  }, []);

  //   const handleSubmit = async (e) => {
  //     e.preventDefault();

  //     try {
  //       const response = await fetch("/api/send-email", {
  //         method: "POST",
  //         headers: { "Content-Type": "application/json" },
  //         body: JSON.stringify(formData),
  //       });

  //       if (response.ok) {
  //         setSubmitStatus({
  //           show: true,
  //           success: true,
  //           message: 'Thank you for contacting us! We will get back to you within 24 hours.'
  //         });
  //         // Clear form
  //         setFormData({
  //           name: '',
  //           email: '',
  //           phone: '',
  //           service: '',
  //           message: ''
  //         });
  //         // Hide message after 5 seconds
  //         setTimeout(() => {
  //           setSubmitStatus({ show: false, success: false, message: '' });
  //         }, 5000);
  //       } else {
  //         setSubmitStatus({
  //           show: true,
  //           success: false,
  //           message: 'Failed to send message. Please try again or call us directly.'
  //         });
  //       }
  //     } catch (error) {
  //       setSubmitStatus({
  //         show: true,
  //         success: false,
  //         message: 'An error occurred. Please try again or contact us by phone.'
  //       });
  //     }
  //   };
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // Save to Firestore
      await addDoc(collection(db, "contact-submissions"), {
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        service: formData.service,
        message: formData.message,
        submittedAt: serverTimestamp(),
        status: "new",
      });

      // Send email
      const response = await fetch("/api/send-email", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setSubmitStatus({
          show: true,
          success: true,
          message:
            "Thank you for contacting us! We will get back to you within 24 hours.",
        });

        // Clear form
        setFormData({
          name: "",
          email: "",
          phone: "",
          service: "",
          message: "",
        });

        setTimeout(() => {
          setSubmitStatus({ show: false, success: false, message: "" });
        }, 5000);
      } else {
        setSubmitStatus({
          show: true,
          success: false,
          message:
            "Failed to send message. Please try again or call us directly.",
        });
      }
    } catch (error) {
      console.error("Error:", error);
      setSubmitStatus({
        show: true,
        success: false,
        message: "An error occurred. Please try again or contact us by phone.",
      });
    }
  };
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const contactInfo = [
    {
      icon: <Phone className="w-8 h-8" />,
      title: "Phone",
      details: "+1 604-512-7113",
      link: "tel:+16045127113",
      color: "#65c063",
      bgColor: "#dcfce7",
    },
    {
      icon: <Mail className="w-8 h-8" />,
      title: "Email",
      details: "support@heartlandhomecare.ca",
      link: "mailto:support@heartlandhomecare.ca",
      color: "#f5a09e",
      bgColor: "#ffe8e6",
    },
    {
      icon: <MapPin className="w-8 h-8" />,
      title: "Location",
      details: "6710 123a Street, Surrey, BC, V3W 0Z1 Canada",
      link: "#",
      color: "#65c063",
      bgColor: "#dcfce7",
    },
    {
      icon: <Clock className="w-8 h-8" />,
      title: "Hours",
      details: "24/7 Available",
      link: "#",
      color: "#f5a09e",
      bgColor: "#ffe8e6",
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section
        className="relative py-20 overflow-hidden"
        style={{
          background:
            "linear-gradient(135deg, #f0fdf4 0%, #fff5f4 50%, #ffe8e6 100%)",
        }}
      >
        <div className="absolute inset-0 opacity-10">
          <div
            className="absolute top-20 left-10 w-96 h-96 rounded-full blur-3xl"
            style={{ backgroundColor: "#f5a09e" }}
          ></div>
          <div
            className="absolute bottom-20 right-10 w-96 h-96 rounded-full blur-3xl"
            style={{ backgroundColor: "#65c063" }}
          ></div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative text-center">
          <div className="inline-block mb-4">
            <span
              className="px-4 py-2 rounded-full text-sm font-medium text-white"
              style={{
                background: "linear-gradient(135deg, #f5a09e, #e88580)",
              }}
            >
              Get In Touch
            </span>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight mb-6">
            We're Here to
            <br />
            <span style={{ color: "#f5a09e" }}>Help </span>
            You and Your
            <span style={{ color: "#65c063" }}> Loved Ones</span>
          </h1>

          <p className="text-lg text-gray-600 leading-relaxed max-w-3xl mx-auto">
            Have questions about our services? Ready to schedule a consultation?
            We're available 24/7 to discuss how we can support your family.
          </p>
        </div>
      </section>

      {/* Contact Form Section */}
      <section
        className="py-20"
        style={{
          background: "linear-gradient(135deg, #fff5f4 0%, #f0fdf4 100%)",
        }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-start">
            {/* Left Side - Info */}
            <div>
              <span
                className="font-semibold text-sm uppercase tracking-wider"
                style={{ color: "#65c063" }}
              >
                Send Us A Message
              </span>
              <h2 className="text-4xl font-bold text-gray-900 mt-2 mb-6">
                Let's Start a Conversation
              </h2>
              <p className="text-gray-600 leading-relaxed mb-8">
                Fill out the form and our team will get back to you within 24
                hours. For immediate assistance, please call us directly.
              </p>

              <div className="space-y-6">
                <div
                  className="flex items-start gap-4 p-6 rounded-2xl"
                  style={{ backgroundColor: "#dcfce7" }}
                >
                  <div
                    className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0"
                    style={{ backgroundColor: "#65c063" }}
                  >
                    <Phone className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-900 mb-1">
                      Call Us Anytime
                    </h3>
                    <p className="text-gray-600 text-sm mb-2">
                      We're available 24/7 for emergencies
                    </p>
                    <a
                      href="tel:+16045127113"
                      className="font-semibold hover:underline"
                      style={{ color: "#65c063" }}
                    >
                      +1 604-512-7113
                    </a>
                  </div>
                </div>

                <div
                  className="flex items-start gap-4 p-6 rounded-2xl"
                  style={{ backgroundColor: "#ffe8e6" }}
                >
                  <div
                    className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0"
                    style={{ backgroundColor: "#f5a09e" }}
                  >
                    <MessageCircle className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-900 mb-1">
                      WhatsApp Us
                    </h3>
                    <p className="text-gray-600 text-sm mb-2">
                      Quick questions? Chat with us instantly
                    </p>
                    <a
                      href="https://wa.me/16045127113"
                      className="font-semibold hover:underline"
                      style={{ color: "#f5a09e" }}
                    >
                      Start Chat
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Side - Form */}
            <div className="bg-white rounded-3xl shadow-2xl p-8 lg:p-10">
              {/* Success/Error Message */}
              {submitStatus.show && (
                <div
                  className={`mb-6 p-4 rounded-2xl border-2 flex items-start gap-3 ${
                    submitStatus.success
                      ? "bg-green-50 border-green-200"
                      : "bg-red-50 border-red-200"
                  }`}
                >
                  <div
                    className={`w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0 ${
                      submitStatus.success ? "bg-green-500" : "bg-red-500"
                    }`}
                  >
                    {submitStatus.success ? (
                      <Check className="w-4 h-4 text-white" />
                    ) : (
                      <X className="w-4 h-4 text-white" />
                    )}
                  </div>
                  <p
                    className={`text-sm font-medium ${
                      submitStatus.success ? "text-green-800" : "text-red-800"
                    }`}
                  >
                    {submitStatus.message}
                  </p>
                </div>
              )}

              <div className="space-y-6">
                <div>
                  <label className="block text-sm font-semibold text-gray-900 mb-2">
                    Your Name *
                  </label>
                  <div className="relative">
                    <User className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      className="w-full pl-12 pr-4 py-4 border-2 border-gray-200 rounded-2xl focus:border-[#65c063] focus:outline-none transition-colors"
                      placeholder="John Doe"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-900 mb-2">
                    Email Address *
                  </label>
                  <div className="relative">
                    <Mail className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      className="w-full pl-12 pr-4 py-4 border-2 border-gray-200 rounded-2xl focus:border-[#65c063] focus:outline-none transition-colors"
                      placeholder="john@example.com"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-900 mb-2">
                    Phone Number *
                  </label>
                  <div className="relative">
                    <Phone className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      className="w-full pl-12 pr-4 py-4 border-2 border-gray-200 rounded-2xl focus:border-[#65c063] focus:outline-none transition-colors"
                      placeholder="+1 (604) 512 7113"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-900 mb-2">
                    Service Interested In
                  </label>
                  <select
                    name="service"
                    value={formData.service}
                    onChange={handleChange}
                    className="w-full px-4 py-4 border-2 border-gray-200 rounded-2xl focus:border-[#65c063] focus:outline-none transition-colors"
                  >
                    <option value="">Select a service</option>
                    <option value="personal-care">Personal Care</option>
                    <option value="companionship">Companionship</option>
                    <option value="homemaking">Homemaking</option>
                    <option value="respite-care">Respite Care</option>
                    <option value="meal-preparation">Meal Preparation</option>
                    <option value="dementia-care">Dementia Care</option>
                    <option value="palliative-care">Palliative Care</option>
                    {/* <option value="transportation">Transportation</option> */}
                    <option value="other">Other</option>
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-900 mb-2">
                    Message *
                  </label>
                  <div className="relative">
                    <MessageSquare className="absolute left-4 top-4 w-5 h-5 text-gray-400" />
                    <textarea
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      rows="5"
                      className="w-full pl-12 pr-4 py-4 border-2 border-gray-200 rounded-2xl focus:border-[#65c063] focus:outline-none transition-colors resize-none"
                      placeholder="Tell us about your care needs..."
                    ></textarea>
                  </div>
                </div>

                <button
                  onClick={handleSubmit}
                  className="w-full text-white px-8 py-4 rounded-full font-semibold hover:shadow-xl transition-all flex items-center justify-center gap-2"
                  style={{
                    background: "linear-gradient(135deg, #65c063, #29a060)",
                  }}
                >
                  <Send className="w-5 h-5" />
                  Send Message
                </button>

                <p className="text-sm text-gray-500 text-center">
                  We respect your privacy. Your information will never be
                  shared.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Contact Info Cards */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {contactInfo.map((item, index) => (
              <a
                key={index}
                href={item.link}
                className="group text-center p-8 rounded-3xl border-2 border-gray-100 hover:shadow-2xl transition-all hover:-translate-y-2"
                style={{ backgroundColor: item.bgColor }}
              >
                <div
                  className="w-16 h-16 rounded-2xl mx-auto mb-4 flex items-center justify-center text-white"
                  style={{ backgroundColor: item.color }}
                >
                  {item.icon}
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">
                  {item.title}
                </h3>
                <p className="text-gray-600 font-medium">{item.details}</p>
              </a>
            ))}
          </div>
        </div>
      </section>
      {/* Map Section */}
      {/* <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <span className="font-semibold text-sm uppercase tracking-wider" style={{color: '#f5a09e'}}>Visit Us</span>
            <h2 className="text-4xl font-bold text-gray-900 mt-2">Our Location</h2>
          </div>
          
          <div className="rounded-3xl overflow-hidden shadow-2xl h-96 bg-gray-200 flex items-center justify-center">
            <div className="text-center p-8">
              <MapPin className="w-16 h-16 mx-auto mb-4" style={{color: '#65c063'}} />
              <h3 className="text-2xl font-bold text-gray-900 mb-2">Surrey, BC, Canada</h3>
              <p className="text-gray-600">Serving the Lower Mainland</p>
            </div>
          </div>
        </div>
      </section> */}

      {/* Map Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <span
              className="font-semibold text-sm uppercase tracking-wider"
              style={{ color: "#f5a09e" }}
            >
              Visit Us
            </span>
            <h2 className="text-4xl font-bold text-gray-900 mt-2">
              Our Location
            </h2>
          </div>

          <div className="rounded-3xl overflow-hidden shadow-2xl h-96 relative">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2607.234567890123!2d-122.87654321!3d49.12345678!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDnCsDA3JzI0LjQiTiAxMjLCsDUyJzM1LjYiVw!5e0!3m2!1sen!2sca!4v1234567890123!5m2!1sen!2sca&q=6710+123a+Street,+Surrey,+BC,+V3W+0Z1"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="6710 123a Street, Surrey, BC Location Map"
            ></iframe>

            {/* Overlay Info Card */}
            <div className="absolute bottom-8 left-1/2 -translate-x-1/2 bg-white rounded-2xl shadow-2xl p-6 text-center z-10">
              <div className="flex items-center justify-center gap-3">
                <div
                  className="w-12 h-12 rounded-full flex items-center justify-center"
                  style={{ backgroundColor: "#dcfce7" }}
                >
                  <MapPin className="w-6 h-6" style={{ color: "#65c063" }} />
                </div>
                <div className="text-left">
                  <h3 className="text-lg font-bold text-gray-900">
                    <a
                      href="https://www.google.com/maps?q=6710+123a+Street,+Surrey,+BC,+V3W+0Z1"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-lg font-bold text-gray-900 hover:underline"
                    >
                      6710 123a Street, Surrey, BC, V3W 0Z1 Canada
                    </a>

                    {/* 6710 123a Street, Surrey, BC, V3W 0Z1 Canada */}
                  </h3>
                  <p className="text-sm text-gray-600">
                    Serving the Lower Mainland
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* WhatsApp Floating Button */}
      <a
        href="https://wa.me/16045127113"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full flex items-center justify-center shadow-2xl hover:scale-110 transition-transform group"
        style={{ background: "#25D366" }}
        aria-label="Chat on WhatsApp"
      >
        <MessageCircle className="w-7 h-7 text-white" />
        <span className="absolute right-16 bg-gray-900 text-white px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity shadow-lg">
          Chat with us
        </span>
      </a>
    </div>
  );
}
